import {
  ExperienceProductDto,
  ExperienceProductVariantDto,
} from "@intelligems/ig-types/dtos/experience-products";
import { ExperienceVariationPriceDto } from "@intelligems/ig-types/dtos/variation-prices";
import { AgProduct } from "@src/store/slices/agProducts/types";
import { getPriceFromExperienceProduct } from "@src/store/slices/agProducts/util/getPriceFromExperienceProduct";
import { parsePrice } from "@src/store/slices/agProducts/util/parsePrice";

export function experienceProductVariantToAgProduct(
  product: ExperienceProductDto,
  variant: ExperienceProductVariantDto
) {
  const agProduct: AgProduct = {
    productId: product.id,
    productTitle: product.title ?? "",
    productImage: product.image || null,
    handle: product.handle,
    variantId: variant.id,
    variantTitle: variant.title ?? "",
    variantPrice: "",
    requiresSellingPlan: false,
    variationPrices: (variant.variationPrices || [])
      .map((group: ExperienceVariationPriceDto) => {
        const price = getPriceFromExperienceProduct(group.price);
        const compareAtPrice = getPriceFromExperienceProduct(
          group.compareAtPrice
        );
        const subscriptionDiscount = getPriceFromExperienceProduct(
          group.subscriptionDiscount
        );

        const sanitizedCompareAtPrice =
          (parsePrice(compareAtPrice) || 0) > 0 ? compareAtPrice : undefined;

        return {
          id: group.id,
          uuid: group.uuid,
          name: group.name,
          variationId: group.variationId,
          price,
          ogPrice: group.price,
          compareAtPrice: sanitizedCompareAtPrice,
          ogComparePrice: group.compareAtPrice,
          subscriptionDiscount,
          subscriptionDiscountType: group.subscriptionDiscountType,
        };
      })
      .reduce((k, v) => ({ ...k, [v.variationId ?? ""]: v }), {}),
  };
  return agProduct;
}
